import Alcohol from "./Alcohol";

export default Alcohol;